module.exports = __webpack_public_path__ + "img/Female.ce17aaf0.png";